export default __webpack_public_path__ + "static/media/kitchen3-afterJ-1024w.dfebdae9.avif";